import metricTypeCheckers from 'types/metricTypeCheckers';

const shouldLeftAlignMetric = (metric?: Metrics.Metric) => {
  if (metric && metricTypeCheckers.isNormalMetric(metric)) {
    if (metric.aggFunc === 'first' || metric.aggFunc === 'last') {
      return true;
    }

    if (
      metric.field.toLowerCase().includes('date') &&
      (metric.aggFunc === 'max' || metric.aggFunc === 'min')
    ) {
      return true;
    }
  }
  return false;
};

export default shouldLeftAlignMetric;
